import { Select } from 'antd'
import React, { useEffect, useState } from 'react'

export const FinanceReportList = ({props,selectFinanceReport}) => {
    const {lstFinanceReport } = props

  const [selectOption, setSelectOption] = useState(null)

    useEffect(()=>{
        const {onGetFinanceReport} = props
        onGetFinanceReport()
    },[])
    useEffect(()=>{
     if(lstFinanceReport.length>0){
      setSelectOption(lstFinanceReport[0].id)
      selectFinanceReport(lstFinanceReport[0].id)

     }
  },[lstFinanceReport])
    const handleChange = (value) => {
      console.log(value);
      selectFinanceReport(value)
      setSelectOption(value)
      };
  return (
    <div>
    {lstFinanceReport.length>0 && 
      <Select
    style={{ width: '100%' }}
    showSearch
    defaultActiveFirstOption={true}
    value={selectOption}
    placeholder="انتخاب سال"
    options={lstFinanceReport.map(task=>({value:task.id,label:"دوره:" + task.period + "-سال: " + task.year}))}
    onChange={handleChange}
    filterOption={(input, option) =>
      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
    }
    />
    }
    </div>
  )
}
